import React, { useState, useRef, useEffect } from 'react';
import { Icon } from '@iconify/react';
// Import your image - adjust the path to match your image location
import AminatImage from '../images/meenatAI.png';


const AIChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: "Hi! 👋 I'm Aminat's AI assistant. I can answer questions about her experience, projects, skills, and more. What would you like to know?"
    }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const saveToFirebase = async (userPrompt, aiResponse) => {
    try {
      // Replace with your Firebase endpoint or function
      await fetch('/api/save-chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userPrompt,
          aiResponse,
          timestamp: new Date().toISOString(),
        }),
      });
    } catch (error) {
      console.error('Error saving to Firebase:', error);
    }
  };

  const handleSend = async () => {
    if (!inputValue.trim()) return;

    const userMessage = inputValue.trim();
    setInputValue('');
    
    // Add user message
    setMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setIsLoading(true);

    try {
      // Call your Vercel AI SDK endpoint
      const response = await fetch('/api/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          messages: [
            ...messages.map(msg => ({
              role: msg.role,
              content: msg.content
            })),
            { role: 'user', content: userMessage }
          ]
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to get response');
      }

      const data = await response.json();
      const assistantMessage = data.message;

      // Add assistant response
      setMessages(prev => [...prev, { 
        role: 'assistant', 
        content: assistantMessage 
      }]);

      // Save to Firebase
      await saveToFirebase(userMessage, assistantMessage);

    } catch (error) {
      console.error('Error:', error);
      setMessages(prev => [...prev, { 
        role: 'assistant', 
        content: "I'm having trouble connecting right now. Please try again or contact Aminat directly at aminatbalogun00@gmail.com" 
      }]);
    }

    setIsLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <>
      {/* Floating Chat Button - Bottom Left */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          bottom: '30px',
          left: '30px',
          zIndex: 9999,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          backgroundColor: 'white',
          border: '2px solid black',
          padding: '12px 20px',
          borderRadius: '50px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.05)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.25)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        }}
      >
        <span style={{ 
          fontFamily: 'Raleway', 
          fontSize: '15px', 
          fontWeight: '600',
          color: 'black',
        }}>
          Ask About Aminat
        </span>
        <div style={{
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          border: '2px solid black',
        }}>
          <img 
            src={AminatImage} 
            alt="Ask Aminat" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover' 
            }} 
          />
        </div>
      </div>

      {/* Backdrop Overlay */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(5px)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          {/* Chat Modal - Center */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '600px',
              maxWidth: '100%',
              height: '700px',
              maxHeight: '90vh',
              backgroundColor: 'white',
              borderRadius: '8px',
              border: '2px solid black',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <div style={{
              backgroundColor: 'black',
              color: 'white',
              padding: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                }}>
                  <img 
                    src={AminatImage} 
                    alt="Aminat" 
                    style={{ 
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'cover' 
                    }} 
                  />
                </div>
                <div>
                  <div style={{ fontFamily: 'Oswald', fontSize: '20px', fontWeight: '500', letterSpacing: '1px' }}>
                    ASK ABOUT AMINAT
                  </div>
                  <div style={{ fontFamily: 'Raleway', fontSize: '13px', opacity: 0.9 }}>
                    AI Assistant
                  </div>
                </div>
              </div>
              <Icon 
                icon="mdi:close" 
                onClick={() => setIsOpen(false)}
                style={{ 
                  fontSize: '28px', 
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>

            {/* Messages */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: '24px',
              backgroundColor: '#fafafa',
            }}>
              {messages.map((msg, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: '16px',
                    display: 'flex',
                    justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start',
                  }}
                >
                  <div
                    style={{
                      maxWidth: '75%',
                      padding: '14px 18px',
                      borderRadius: '12px',
                      backgroundColor: msg.role === 'user' ? 'black' : 'white',
                      color: msg.role === 'user' ? 'white' : '#333',
                      fontFamily: 'Raleway',
                      fontSize: '15px',
                      lineHeight: '1.6',
                      border: msg.role === 'assistant' ? '1px solid #e0e0e0' : 'none',
                    }}
                  >
                    {msg.content}
                  </div>
                </div>
              ))}
              {isLoading && (
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '16px' }}>
                  <div style={{
                    padding: '14px 18px',
                    borderRadius: '12px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                  }}>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: 'black',
                        animation: 'bounce 1.4s infinite ease-in-out both',
                        animationDelay: '0s',
                      }} />
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: 'black',
                        animation: 'bounce 1.4s infinite ease-in-out both',
                        animationDelay: '0.2s',
                      }} />
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: 'black',
                        animation: 'bounce 1.4s infinite ease-in-out both',
                        animationDelay: '0.4s',
                      }} />
                    </div>
                  </div>
                </div>
              )}
              <div ref={messagesEndRef} />
            </div>

            {/* Input */}
            <div style={{
              padding: '20px',
              backgroundColor: 'white',
              borderTop: '2px solid #e0e0e0',
              display: 'flex',
              gap: '12px',
            }}>
              <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Ask me anything about Aminat..."
                style={{
                  flex: 1,
                  padding: '14px',
                  border: '1px solid #333',
                  borderRadius: '4px',
                  fontFamily: 'Raleway',
                  fontSize: '15px',
                  outline: 'none',
                  transition: 'border-color 0.3s ease',
                }}
                onFocus={(e) => e.target.style.borderColor = 'black'}
                onBlur={(e) => e.target.style.borderColor = '#333'}
              />
              <button
                onClick={handleSend}
                disabled={!inputValue.trim() || isLoading}
                style={{
                  backgroundColor: inputValue.trim() ? 'black' : '#ccc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '14px 20px',
                  cursor: inputValue.trim() ? 'pointer' : 'not-allowed',
                  transition: 'all 0.3s ease',
                  fontFamily: 'Oswald',
                  letterSpacing: '1px',
                }}
                onMouseEnter={(e) => {
                  if (inputValue.trim()) {
                    e.target.style.backgroundColor = '#333';
                  }
                }}
                onMouseLeave={(e) => {
                  if (inputValue.trim()) {
                    e.target.style.backgroundColor = 'black';
                  }
                }}
              >
                <Icon icon="mdi:send" style={{ fontSize: '20px' }} />
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}</style>
    </>
  );
};

export default AIChatbot;